export const GET_UPCOMMING_APPOINTMENTS = 'GET_UPCOMMING_APPOINTMENTS';
export const GET_PAST_APPOINTMENTS = 'GET_PAST_APPOINTMENTS';
export const APPOINTMENTS_FAIL = 'APPOINTMENTS_FAIL';